import { FC } from 'react';
import { StyledHighlighter } from './styles';

type Props = {
  search: string;
  text: string;
};

export const Highlighter: FC<Props> = ({ search, text }) => {
  return (
    <StyledHighlighter
      searchWords={[search]}
      caseSensitive={false}
      textToHighlight={text}
      autoEscape
    />
  );
};
